module.exports = __webpack_public_path__ + "f57cfa5038a0a7ccd860bfe194c55007.woff";


//////////////////
// WEBPACK FOOTER
// ./src/shared/fontello/font/fontello.woff
// module id = 1101
// module chunks = 0 1 2 3 4